__webpack_require__.p = "https://static.magicsquare.io/store/_next/";